import { UserCircle2Icon } from "lucide-react";
import React, { useEffect, useState } from "react";
import DropdownProfile from "./DropdownProfile";
import { Nav } from "react-bootstrap";
import "../../_css/Header.css";
import { useDispatch } from "react-redux";
import { getUserInfo } from "../../requests";
import { setUserInformation } from "../../_store/reducers/userReducer";
import { deleteAuthToken } from "../../utils/helper";

const Header = () => {
  const dispatch = useDispatch();
  const [userInfo, setUserInfo] = useState({});
  useEffect(() => {
    getUserInfo()
      .then((res) => {
        // EXTRACT USER INFORMATION FROM RESPONSE
        const { fullName, id, email, accountStatus, tncStatus, image, phone } =
          res.data.response;
        setUserInfo(res.data.response);

        // STORE USER INFORMATION IN REDUX
        dispatch(
          setUserInformation(
            fullName,
            id,
            email,
            accountStatus,
            tncStatus,
            image,
            phone
          )
        );
      })
      .catch((error) => {
        if (error?.response?.status === 401) {
          deleteAuthToken();
          window.location.reload();
        }
        console.log(error);
      });
  }, []);

  return (
    <Nav className="header-nav navbar justify-content-end d-flex">
      <div className="d-flex align-items-center gap-2">
        {/* <UserCircle2Icon size={34} className="pe-cursor my-3 rounded-full" /> */}
        <div className="d-flex align-items-center justify-content-center">
          {userInfo.image ? (
            <img
              src={userInfo.image}
              alt="User"
              className="rounded-full"
              style={{
                width: "2.5rem",
                height: "2.5rem",
                borderRadius: "50%",
                objectFit: "cover",
                margin: "6px 0",
              }}
            />
          ) : (
            <UserCircle2Icon
              size={34}
              className="pe-cursor my-3 rounded-full"
            />
          )}
        </div>
        <DropdownProfile userName={userInfo.fullName} />
      </div>
      {/* {!isPendingUser && location.pathname.includes("offer-management") && (
        <NavLink
          to="/offer-management"
          className="nav-link"
          activeclassname={styles.active}
          onClick={(event) => event.preventDefault()}
        >
          <OverlayTrigger placement="right" overlay={tooltipOfferManagement}>
            <i>
              <Fan alt="Offer Management" className={styles.icon} />
            </i>
          </OverlayTrigger>
        </NavLink>
      )} */}
      {/* <NavLink
        to="/logout"
        className={`nav-link ${styles["bottom-0"]}`}
        onClick={(e) => e.preventDefault()}
        activeclassname={styles.active}
      >
        <SignOutButton />
        <img src={logoutIcon} alt="Logout" className={styles.icon} />
      </NavLink> */}
    </Nav>
  );
};

export default Header;
